import LegacyParity from './LegacyParity'

export default function App() {
  return <LegacyParity />
}
